export const MAX_FILE_SIZE_IN_MB = 10

export const MAX_FILE_SIZE_IN_BYTES = MAX_FILE_SIZE_IN_MB * 1024 * 1024

export const isImage = (file: File): boolean => {
  return ['image/jpeg', 'image/png'].includes(file.type) && file.size <= MAX_FILE_SIZE_IN_BYTES
}
